"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardCost = void 0;
var vue_1 = require("vue");
var PreferencesManager_1 = require("./../PreferencesManager");
exports.CardCost = vue_1.default.component('CardCost', {
    props: {
        amount: {
            type: Number,
        },
        newCost: {
            type: Number,
        },
    },
    methods: {
        getClasses: function () {
            var classes = ['card-cost'];
            if (this.amount === undefined) {
                classes.push('visibility-hidden');
            }
            return classes.join(' ');
        },
        displayTwoCosts: function () {
            var hideDiscount = PreferencesManager_1.PreferencesManager.loadBoolean('hide_discount_on_cards');
            return this.newCost !== undefined && this.newCost !== this.amount && !hideDiscount;
        },
    },
    template: "\n    <div>\n        <div :class=\"getClasses()\">{{ amount === null ? 0 : amount }}</div>\n        <template v-if=\"displayTwoCosts()\">\n          <div class=\"card-cost-transition\"></div>\n          <div class=\"card-old-cost\">{{ newCost }}</div>\n        </template>\n    </div>\n    ",
});
//# sourceMappingURL=CardCost.js.map